// Новая сборка на сервере → перезагрузка (2026-10-20). CRM — SPA: открытая вкладка (особенно
// в Safari на телефоне) живёт днями на старом коде и после выкладки не видит исправлений
// (так «пропала» вернувшаяся кнопка меню). Сверяем buildId с /_nuxt/builds/latest.json
// при старте, раз в 10 минут и при возврате на вкладку. Перезагружаем на ближайшем переходе
// между страницами (не посреди набора текста) или сразу, если вкладка была в фоне ≥10 минут.
const CHECK_EVERY_MS = 10 * 60_000
const LONG_HIDDEN_MS = 10 * 60_000

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig()
  const buildId = config.app.buildId
  if (!buildId || import.meta.dev) return
  const base = (config.app.baseURL || '/').replace(/\/$/, '')
  const assets = (config.app.buildAssetsDir || '/_nuxt/').replace(/^\/?/, '/').replace(/\/?$/, '/')
  const manifestUrl = `${base}${assets}builds/latest.json`

  let stale = false
  let lastCheck = 0
  let hiddenAt = 0

  async function check() {
    if (stale || Date.now() - lastCheck < 60_000) return stale
    lastCheck = Date.now()
    try {
      const res = await fetch(`${manifestUrl}?t=${Date.now()}`, { cache: 'no-store' })
      if (res.ok) {
        const latest = await res.json()
        stale = !!latest?.id && latest.id !== buildId
      }
    } catch { /* нет сети — проверим в следующий раз */ }
    return stale
  }

  const router = useRouter()
  router.beforeEach((to) => {
    if (!stale) return
    window.location.assign(base + to.fullPath)
    return false
  })

  document.addEventListener('visibilitychange', async () => {
    if (document.visibilityState === 'hidden') {
      hiddenAt = Date.now()
      return
    }
    const longHidden = hiddenAt && Date.now() - hiddenAt >= LONG_HIDDEN_MS
    if ((await check()) && longHidden) window.location.reload()
  })

  check()
  setInterval(check, CHECK_EVERY_MS)
})
